import { createReducer } from '../utils';
import { GET_UI_CONFIG_START, GET_UI_CONFIG_DONE, GET_UI_CONFIG_ERROR } from '../actions';

const initialState = {
    loading: false,
    data: null,
    error: null
};

export default createReducer(initialState, {
    [GET_UI_CONFIG_START]: (state) => {
        return Object.assign({}, state, {
            loading: true
        });
    },
    [GET_UI_CONFIG_DONE]: (state, payload) => {
        const [ uiConfig ] = payload.data;
        return Object.assign({}, state, {
            loading: false,
            data: uiConfig
        });
    },
    [GET_UI_CONFIG_ERROR]: (state, payload) => {
        return Object.assign({}, state, {
            loading: false,
            error: payload.data
        });
    }
});
